<template>
  <v-select
    v-model="ratings"
    :items="items"
    :style="`max-width: ${width}px;min-width: ${width}px;width: ${width}px`"
    class="mt-2 px-2"
    dense
    :menu-props="{offsetY: true, minWidth: width}"
    :label="label"
    multiple
    hide-details
    :append-icon="ratings.length === 5 ? '$dropdown' : null"
    :append-outer-icon="ratings.length > 0 && ratings.length < 5 ? 'mdi-close' : null"
    @click:append-outer="clear"
    @change="ratingsChanged"
  >
    <template #selection="{ item, index }">
      <span v-if="ratings.length < 5">
        {{ item }}<template v-if="index < ratings.length-1">,&nbsp;</template>
      </span>
      <span v-else-if="ratings.length === 5 && index === 0">{{ $t('label.all') }}</span>
    </template>
  </v-select>
</template>

<script setup lang="ts">
import { PropType, ref, watch } from 'vue';
import { TranslateResult } from 'vue-i18n';

const props = defineProps(
  {
    label: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
    width: { type: Number as PropType<Number>, required: true, default: 110 },
    value: { type: Object as PropType<Array<number>>, required: true },
  },
);

const emit = defineEmits(['input']);

const items = [1, 2, 3, 4, 5];

const ratings = ref(props.value);

const clear = () => { ratings.value = items; emit('input', ratings.value); };

watch(() => props.value, () => { ratings.value = props.value; });

const ratingsChanged = () => {
  if (ratings.value.length === 0) {
    ratings.value = items;
  }
  ratings.value = ratings.value.sort((n1, n2) => n1 - n2);
  emit('input', ratings.value);
};

</script>
